import { OnboardingState } from '@repo/domain/user';

import { OnboardingStepConfig } from '../types';

export const isValidUserStep = (step: OnboardingStepConfig): boolean => {
  return step && !step.isSkip && step.name !== OnboardingState.Complete;
};
